<template>
  <logged-in-layout>
    <main>
      <h1>Live Coach</h1>
      <live-coach />
    </main>
  </logged-in-layout>
</template>

<script>
  import LoggedInLayout from '@/components/logged-in-layout/logged-in-layout'
  import LiveCoach from 'vue-components/live-coach/components/live-coach'

  export default {
    components: {
      LoggedInLayout,
      LiveCoach
    }
  }
</script>



// WEBPACK FOOTER //
// live-coach.vue?8ea39af4